import { type FC } from 'react'
import { IntegrationServiceId, type WorkflowSupportedIntegration } from '../../../../../../common/integrations'
import { RedtailStartWorkflowForm } from './redtail/RedtailStartWorkflowForm'
import { type StartWorkflowFormProps } from './StartWorkflowFields'
import { WealthboxStartWorkflowForm } from './wealthbox/WealthboxStartWorkflowForm'

const START_WORKFLOW_FORMS: Record<WorkflowSupportedIntegration, FC<StartWorkflowFormProps>> = {
  [IntegrationServiceId.WEALTHBOX]: WealthboxStartWorkflowForm,
  [IntegrationServiceId.REDTAIL]: RedtailStartWorkflowForm,
}

export const StartWorkflowForm: FC<StartWorkflowFormProps> = (props) => {
  const Form = START_WORKFLOW_FORMS[props.target.serviceId]
  return <Form {...props} />
}
